'use strict'

import Vue from 'vue'
import axios from 'axios'
import router from '../router'
import { CONFIG } from '../config'

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let config = {
  baseURL: CONFIG.URL
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
}

const _axios = axios.create(config)

_axios.interceptors.request.use(
  function (config) {
    // Do something before request is sent

    if (localStorage.getItem('is_login') > 0) {
      config.headers['token'] = localStorage.getItem('token')
    }
    config.params = {
      ...config.params,
      tenant_id: CONFIG.TENANT_ID
    }

    return config
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error)
  }
)
// Add a response interceptor
_axios.interceptors.response.use(
  function (response) {
    return response
  },
  function (error) {
    // Do something with response error
    // 当未登录时跳转至登录页面
    if (error.response.data.code === 401 && error.response.data.msg === 'Please login first') {
      localStorage.removeItem('is_login')
      localStorage.removeItem('uid')
      localStorage.removeItem('token')

      router.push('/login')
    }
    return Promise.reject(error)
  }
)

Plugin.install = function (Vue, options) {
  Vue.axios = _axios
  window.axios = _axios
  Object.defineProperties(Vue.prototype, {
    axios: {
      get () {
        return _axios
      }
    },
    $axios: {
      get () {
        return _axios
      }
    }
  })
}

Vue.use(Plugin)

export default Plugin
